// NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const NotFound = () => {
  return (
    <>
      <Header />
      <div
        className="not-found-page"
        style={{
          padding: "100px 20px",
          textAlign: "center",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="container">
          <h1
            style={{
              fontSize: "4rem",
              marginBottom: "1rem",
              color: "var(--primary-green)",
            }}
          >
            404
          </h1>
          <h2 style={{ marginBottom: "1.5rem" }}>Page Not Found</h2>
          <p style={{ marginBottom: "2rem", fontSize: "1.2rem" }}>
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="btn btn-primary"
            style={{ padding: "12px 24px", textDecoration: "none" }}
          >
            Go Back Home
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
